import type {AgentProfile} from '../agent-profile'

/**
 * Profile overrides for the Copilot Cloud Agent (copilot-developer).
 *
 * The cloud agent is mostly "default" behavior, plus:
 * - Agent grouping for sub-agent log entries (with feature flag)
 * - Model picker in the header (with feature flag)
 */
export const CLOUD_AGENT_PROFILE: Partial<AgentProfile> = {
  slug: 'copilot-developer',
  displayName: 'Copilot',

  enableAgentGrouping: true,
}
